import { Button } from '../primitives/button';

type Props = {
    actionLabel: string;
    onAction: () => void;
};

export function NotFound({ actionLabel, onAction }: Props) {
    return (
        <div className="flex-1 self-stretch flex flex-col items-center justify-start px-8 pt-28 gap-7.5 overflow-hidden md:grid md:grid-rows-1 md:grid-cols-[minmax(0,1fr)_minmax(auto,1fr)] md:items-stretch md:pt-0 md:gap-0 md:px-4">
            <div className="relative w-full md:order-2 md:w-auto">
                <img
                    src="/404-illustration.svg"
                    alt=""
                    className="block w-full h-auto mix-blend-multiply pointer-events-none select-none md:absolute md:top-1/2 md:-left-20 md:-translate-y-1/2 md:w-[calc(100%+80px)] md:max-w-[792.5px]"
                />
            </div>
            <div className="flex flex-col gap-7.5 items-start w-full max-w-127 md:order-1 md:justify-center md:justify-self-end md:px-2.5">
                <div className="flex flex-col gap-4 items-start w-full">
                    <h1 className="text-4xl font-bold leading-none text-foreground md:text-5xl md:leading-12">
                        Page not found
                    </h1>
                    <p className="text-xl font-normal leading-7 text-muted-foreground md:text-2xl md:font-medium md:leading-8">
                        The page may have been moved, renamed, or never existed. Let’s get you back
                        to where you need to be.
                    </p>
                </div>
                <Button size="lg" onClick={onAction}>
                    {actionLabel}
                </Button>
            </div>
        </div>
    );
}
